import _ = require("underscore");
import Portal = require("portal-gis");
import Base = require("../base-command");
import Controller = require("../../controls/controller");
import Utils = require("../../utils");

class GeoqueryHandler<T> extends Base<T> {

    static about = `
Assigns a key value to each feature using an underscore template provided by the _key-template_ option.
The unique value is stored as the _id_ attribute of the feature.

This is a command helper used by other commands. The _assignKeys_ method to performs the work.
    `;

    static options = Utils.defaults({
        "key-template": {
            about: "required underscore template to produce a unique id from feature attributes"
        }
    }, Base.options);

    /**
     * assigns 'id' to each feature in the layer
     */
    assignKeys(layer: Rhythm.GIS.FeatureQueryResultLayer) {
        if (!layer || !layer.features || !layer.features.length) return;

        let templateStr = this.options["key-template"];
        if (!templateStr) {
            console.warn("key-template is a require option");
            let f1 = layer.features[0];
            if (f1) {
                templateStr = _.keys(f1.attributes)
                    .filter(k => 0 < "_stringnumber".indexOf(typeof f1.attributes[k]))
                    .map(k => `<%=${k}%>`).join(":");
                console.log("key-template: ", templateStr);
            }
        }
        if (templateStr) {
            try {
                let template = _.template(templateStr);
                layer.features.forEach(f => f.attributes["id"] = template(f.attributes));
            } catch (ex) {
                console.error("invalid key-template: ", templateStr, ex);
            }
        }
    }

}

export = GeoqueryHandler;